import { useState } from 'react';

export default function AIAboutGenerator({ category, location, business_name ,onResult }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [generatedText, setGeneratedText] = useState('');

  console.log("📦 AIAboutGenerator received ->", { category, location,business_name });

  const handleGenerate = async () => {
    if (!category || !location || !business_name) {
      setError("Category , location & Business Name are required");
      return;
    }

    try {
      setLoading(true);
      setError('');

      const prompt = `Write an 'About Us' section for a business named as '${business_name}' in the '${category}' category, located in '${location}', using a 'warm' tone. Make it culturally relevant for Indian audiences in the USA, and under 100 words.Do not ask any further question on the response `;

      const response = await fetch('https://api.openai.com/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer 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`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          model: 'gpt-3.5-turbo-0125',
          messages: [
            { role: 'system', content: 'You are a helpful business writing assistant.' },
            { role: 'user', content: prompt }
          ]
        }),
      });

      const result = await response.json();
      const content = result.choices?.[0]?.message?.content || 'No content generated';
      setGeneratedText(content);

      if (onResult) onResult(content);
    } catch (err) {
      console.error('🔥 AI generation failed:', err);
      setError('Failed to generate content.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-4">
      <button
        className={`px-4 py-2 rounded text-white ${category && location ? 'bg-[#D97706] hover:bg-[#b35f00]' : 'bg-gray-300 cursor-not-allowed'}`}
        onClick={handleGenerate}
        disabled={!category || !location || loading}
      >
        {loading ? 'Generating...' : '✨ AI Generate About Us'}
      </button>
      {generatedText && (
        <div className="mt-4 bg-white border border-gray-300 p-4 rounded shadow-md w-80">
          <h4 className="font-bold text-lg mb-2">Generated Text:</h4>
          <pre className="whitespace-pre-wrap text-sm text-gray-800">{generatedText}</pre>
          <div className="mt-3 flex justify-end">
            <button
              className="px-3 py-1 bg-green-600 text-white text-sm rounded hover:bg-green-700"
              onClick={() => navigator.clipboard.writeText(generatedText)}
            >
              📋 Copy to Clipboard
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
